import React, { useState } from "react";
import { RiDeleteBin6Fill } from "react-icons/ri";
import DateInput from "../../commonComponent/CutomDatePicker";
import moment from "moment";
import { FiPlus } from "react-icons/fi";
import { BiSolidEditAlt, BiSolidTimeFive } from "react-icons/bi";
import { BsCalendarDate } from "react-icons/bs";
import {
  format24Time,
  isEmpty,
  showToastError,
  showToastSuccess,
} from "../../Utils/Helper";
import { useEffect } from "react";
import { AddReminder, deleteReminder } from "../../services/ReminderService";
import { toastMsg } from "../../Utils/AllConstant";
import Dash_TimePickerModule from "./Dash_TimePickerModule";

function ReminderAdd({ getReminders, reminders, handleClose, data }) {
  const [newTime, setNewTime] = useState("");
  const [title, setTitle] = useState("");
  const [remDate, setRemDate] = useState(new Date());
  const [dateTime, setDateTime] = useState();
  // const [editIndex, setEditIndex] = useState(-1);
  const [error, setError] = useState(false);
  const [apiParams, setApiParams] = useState("new");
  const [reminderId, setReminderId] = useState();
  //   const [reminders, setReminders] = useState([])

  console.log(reminders, "task");
  useEffect(() => {
    getReminders();
  }, []);

  useEffect(() => {
    if (data) {
      handleChange(data);
    }
  }, [data]);

  //   const getReminders = async() => {
  //     try {
  //       const response = await getReminder()
  //       if(response.status === 200){
  //         setReminders(response?.data?.data)
  //       }
  //     } catch (error) {
  //       setReminders([]);
  //       error?.data?.data &&
  //         console.log(error?.data?.data || error.data?.message);
  //     }
  //   }

  const chechValidation = () => {
    let errorsResult = error;
    let isValid = true;
    if (!title || isEmpty(title)) {
      isValid = false;
      errorsResult = { ...errorsResult, description: true };
    }
    if (!newTime || isEmpty(newTime)) {
      isValid = false;
      errorsResult = { ...errorsResult, newTime: true };
    }
    if (!remDate || isEmpty(remDate)) {
      isValid = false;
      errorsResult = { ...errorsResult, remDate: true };
    }
    setError(errorsResult);
    return isValid;
  };

  const handleReminder = async (e, task) => {
    e.preventDefault();
    if (chechValidation()) {
      var parms = {};
      if (apiParams === "new") {
        parms["title"] = title;
        parms["type"] = "reminder";
        parms["dateTime"] = dateTime;
        parms["isCompleted"] = [];
      } else {
        parms["typeId"] = reminderId;
        parms["title"] = title;
        parms["type"] = "reminder";
        parms["dateTime"] = dateTime;
        parms["isCompleted"] = [];
      }
      try {
        const response = await AddReminder(parms);
        if (response.status === 200) {
          showToastSuccess("Reminder Created");
          getReminders();
          // setEditIndex(-1);
          setApiParams("new");
          setTitle("");
          setRemDate(new Date());
          setNewTime("");
          setError(false)
        } else {
          showToastError(
            response?.data || response.message || toastMsg.errorMssg
          );
        }
      } catch (error) {
        showToastError(
          error?.data?.data || error?.data?.message || toastMsg.errorMssg
        );
      }
    }
  };

  const handleChange = (reminder) => {
    setReminderId(reminder._id);
    setNewTime(moment(new Date(reminder?.dateTime)).format("hh:mm A"));
    setTitle(reminder?.title);
    setRemDate(new Date(reminder?.dateTime));
    setApiParams("edit");
  };

  const deleteRemind = async (id) => {
    // console.log(id)
    try {
      const response = await deleteReminder(id);
      if (response.status === 200) {
        showToastSuccess("Reminder Removed");
        getReminders();
      } else {
        showToastError(
          response?.data || response.message || toastMsg.errorMssg
        );
      }
    } catch (error) {
      showToastError(
        error?.data?.data || error.data?.message || toastMsg.errorMssg
      );
    }
  };

  const handleConversion = () => {
    let time =
      moment(remDate).format("YYYY-MM-DD") +
      "T" +
      format24Time(newTime) +
      ":00.000+05:30";
    setDateTime(time);
  };
  console.log(dateTime);
  // console.log(reminderId)

  useEffect(() => {
    handleConversion();
  }, [newTime, remDate]);

  console.log(
    new Date(),
    new Date(
      moment(remDate).format("YYYY-MM-DD") +
      "T" +
      format24Time(newTime) +
      ":00.000+05:30"
    )
  );

  return (
    <>
      <div
        className="row justify-content-between px-2 row-gap-4"
        style={{ width: "600px" }}
      >
        <div className="col-md-12">
          <input
            name="title"
            type="text"
            className="description_inputf  "
            placeholder="Reminder"
            value={title}
            onChange={(e) => {
              setTitle(e.target.value);
            }}
          />
          {error.description ? (
            <h6
              className="text-danger error"
              style={{ marginBottom: 15, marginTop: -23 }}
            >
              {"Please select description"}
            </h6>
          ) : null}
        </div>
        <div className="col-md-6">
          <DateInput
            value={remDate}
            placeHolder={"Please choose..."}
            onChangeDate={(date) => {
              setRemDate(date);
              // console.log("Date TZ", convertDateTimeToTZ(date))
              //   setError({ ...error, sessionDate: false });
              // console.log(date);
            }}
            imageStyle={{
              width: "22px",
              height: "22px",
              position: "absolute",
              borderRadius: "0px",
              marginBlock: "17px",
              left: "20px",
            }}
            inputClassName={"description_inputf d-flex align-items-center"}
          />
          {error.description ? (
            <h6
              className="text-danger error"
              style={{ marginBottom: 15, marginTop: -23 }}
            >
              {"Please select start date"}
            </h6>
          ) : null}
        </div>

        <div className="col-md-6">
          <Dash_TimePickerModule
            defaultValue={
              newTime
                ? `${new Date(
                  moment(remDate).format("YYYY-MM-DD") +
                  "T" +
                  format24Time(newTime) +
                  ":00.000+05:30"
                )}`
                : `${new Date()}`
            }
            setNewData={setNewTime}
          // selectedDate={selectedDate}
          />
          {error.description ? (
            <h6
              className="text-danger error"
              style={{ marginBottom: 15, marginTop: -23 }}
            >
              {"Please select time"}
            </h6>
          ) : null}
        </div>
        <div className="col-md-12 d-flex align-items-center gap-2 pointer"
          onClick={(e) => {
            handleReminder(e);
          }}>
          <span
            className=" text-white bold px-1 py-1 d-flex justify-content-center align-items-center "
            style={{
              borderRadius: "50%",
              backgroundColor: "rgba(31, 126, 120, 1)",
            }}
          >
            <FiPlus fontSize={"0.8rem"} fontWeight={"bold"} />
          </span>
          <a
            style={{ color: "rgba(31, 126, 120, 1)" }}
          >
            {apiParams === "edit" ? "Edit" : "Add"}
          </a>
        </div>
        {reminders?.length > 0 ? (
          <div
            className="col-md-12 mt-1 overflow-y-scroll overflow-x-hidden d-block "
            style={{ height: "200px", width: "100%" }}
          >
            <table cellPadding={"8px"} style={{ width: "100%" }}>
              <thead>
                <th>Reminder Title</th>
                <th>Date</th>
                <th>Time</th>
                <th>Actions</th>
              </thead>
              <tbody>
                {reminders?.map((task) => {
                  console.log(
                    moment(new Date(task?.dateTime)).format("hh:mm a")
                  );
                  console.log(task?.dateTime, task?.title);
                  return (
                    <tr
                      className="align-items-center"
                      style={{
                        backgroundColor: "rgba(227, 236, 237, 1)",
                      }}
                    >
                      <td>{task?.title}</td>
                      <td>
                        <span className="px-1">
                          <BsCalendarDate
                            color="rgba(21, 101, 99, 1)"
                            size={"20px"}
                          />
                        </span>{" "}
                        <span>{new Date(task?.dateTime).toDateString()}</span>
                      </td>
                      <td>
                        <span className="px-1">
                          <BiSolidTimeFive
                            color="rgba(21, 101, 99, 1)"
                            size={"20px"}
                          />
                        </span>{" "}
                        <span>
                          {moment(new Date(task?.dateTime)).format("HH:mm")}
                        </span>
                      </td>
                      <td className="">
                        <button
                          className="btn me-2"
                          style={{ backgroundColor: "rgba(31, 126, 120, 0.2)" }}
                          onClick={() => {
                            // setReminderId(task._id);
                            handleChange(task);
                          }}
                        >
                          <BiSolidEditAlt size={"20px"} />{" "}
                        </button>
                        <button
                          className="btn"
                          style={{ backgroundColor: "rgba(31, 126, 120, 0.2)" }}
                          onClick={() => deleteRemind(task._id)}
                        >
                          <RiDeleteBin6Fill size={"20px"} />{" "}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : null}

        <div className="d-flex justify-content-center mt-3">
          <button
            className="btn text-white"
            style={{ backgroundColor: "rgba(31, 126, 120, 1)" }}
            onClick={(e) => {
              handleReminder(e);
              handleClose();
            }}
          >
            {apiParams === "edit" ? "Update" : "Submit"}
          </button>
        </div>
      </div>
      {/* {reminders?.length > 0 ? ( */}

      {/* ) : null} */}
    </>
  );
}

export default ReminderAdd;
